<template>
  <div>
    <Dialog
      v-bind="$attrs"
      v-on="$listeners"
      :visible="show"
      :title="title || locale.sharePage"
      :hasDecor="false"
    >
      <h3 class="ff--trajanpro-bold">
        {{ content || locale.chooseShareMethod }}
      </h3>
      <ul @click="share()" class="ff--trajanpro-bold">
        <li
          v-gtag:share="'facebook'"
          @click="share('facebook')"
          data-method="facebook"
          data-type="button"
          class="share-method"
        >
          <div class="share-method__img"></div>
          <span>Facebook</span>
        </li>
        <li
          v-gtag:share="'message'"
          @click.stop="share('message')"
          data-method="message"
          data-type="button"
          class="share-method"
        >
          <div class="share-method__img"></div>
          <span>Message</span>
        </li>
        <li
          v-gtag:share="'twitter'"
          @click="share('twitter')"
          data-method="twitter"
          data-type="button"
          class="share-method"
        >
          <div class="share-method__img"></div>
          <span>Twitter</span>
        </li>
        <li
          v-gtag:share="'mail'"
          @click="share('mail')"
          data-method="mail"
          data-type="button"
          class="share-method"
        >
          <div class="share-method__img"></div>
          <span>Mail</span>
        </li>
        <li
          v-gtag:copyLink
          data-method="copy"
          ref="copyLink"
          data-type="button"
          class="share-method"
          @click="share('copy')"
        >
          <div class="share-method__img"></div>
          <span>Copy Link</span>
        </li>
      </ul>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "./dlg.vue";
import { CopyText } from "scripts/util";
import { mapActions } from "vuex";

export default {
  name: "ShareDialog",
  props: ["name", "visible", "title", "content"],
  components: {
    Dialog,
  },
  data() {
    return {
      locale: this.$locale.dialog.share,
      show: false,
    };
  },
  created() {},
  mounted() {},
  watch: {
    visible: {
      handler(val) {
        this.show = val;
        if (val) {
          this.$nextTick(() => {
            CopyText(this.$refs.copyLink, location.href);
          });
        }
      },
      immediate: true,
    },
  },
  filters: {
    formatter(val, replacer) {
      if (!Array.isArray(replacer)) {
        replacer = [replacer];
      }
      const res = val?.replaceAll(/\$\{(\d+)\}/g, function () {
        return replacer[arguments[1]];
      });
      return res;
    },
  },
  computed: {},
  methods: {
    ...mapActions(["sharePlatform"]),
    close() {
      this.show = false;
      this.$emit("close");
    },
    share(platform) {
      if (!platform) {
        this.sharePlatform();
        return;
      }

      if (platform == "message") {
        this.$message(this.$locale.dialog.share.onlyAvailableOnMobile);
        return;
      }

      if (platform == "copy") {
        this.$message.success(this.$locale.rewards.copied);
        return;
      }

      this.$share(platform);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .dialog {
  &-body {
    padding: 80px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 25px;
    text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
      0px 0px 1px rgba(255, 233, 129, 0.69);
  }
}

h3 {
  margin: 0 0 50px;
  font-weight: normal;
  color: var(--primary-color);
}

ul {
  display: flex;
  justify-content: space-between;

  .share-method {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 30px;
    }

    &__img {
      margin-bottom: 10px;
      width: 80px;
      height: 80px;
      background: no-repeat center;
      background-size: 80%;
    }

    &[data-method="facebook"] {
      .share-method__img {
        background-image: url(~images/dialog/facebook.png);
      }
    }

    &[data-method="message"] {
      .share-method__img {
        background-image: url(~images/dialog/message.png);
      }
    }

    &[data-method="twitter"] {
      .share-method__img {
        background-image: url(~images/dialog/twitter.png);
      }
    }

    &[data-method="mail"] {
      .share-method__img {
        background-image: url(~images/dialog/mail.png);
      }
    }

    &[data-method="copy"] {
      .share-method__img {
        background-image: url(~images/dialog/copy.png);
      }
    }

    span {
      font-size: 22px;
      color: #e5ddc9;
    }
  }
}
</style>
